module.exports = __webpack_public_path__ + "static/media/infoIcon.ad039b1b.png";